import VideoControlCompareReportStyle from "./video-control-compare-report.module.scss";
import  * as React from "react";
import { observer } from "mobx-react";
import { IVideoControlCompareReportProps } from "./IVideoControlCompareReportProps";
import { SingleVideo } from "../SingleVideo/SingleVideo";
import { IReportVideo } from "Data";

@observer
export class VideoControlCompareReport extends React.Component<IVideoControlCompareReportProps> {
    private numbersOfVideosToDisplay: number = 2;
    private readonly fixedSelectedVideos: IReportVideo[];

    constructor(props: IVideoControlCompareReportProps) {
        super(props, undefined);
        
        if (this.props.selectedVideos.length !== this.numbersOfVideosToDisplay) {
            this.fixedSelectedVideos = [
                ...this.props.selectedVideos,
                ...(Array<IReportVideo>(this.numbersOfVideosToDisplay - this.props.selectedVideos.length) as any).fill(null)
            ];
        } else {
            this.fixedSelectedVideos = this.props.selectedVideos;
        }

        this.onSelectedVideosChanged = this.onSelectedVideosChanged.bind(this);
    }

    private shouldShowAngleButtons(): boolean {
        return ((this.props.videos && this.props.videos.length) ?? 0) > 1;
        
    }

    private shouldShowAngleButtons2(): boolean {
        return ((this.props.videos2 && this.props.videos2.length) ?? 0) > 1;
    }

    private onSelectedVideosChanged(video: IReportVideo, index: number) {
        this.fixedSelectedVideos[index] = video;
        this.props.onSelectedVideosChanged(this.fixedSelectedVideos);
    }

    render() {
        return <div className={`${VideoControlCompareReportStyle.videoControlCompareReport} row`}>
                   {this.props.videos && this.props.videos.length > 0
                    ?
                        <div className={"single-video" + (this.props.videos.length === 1 || this.props.videos.length === 2 ? ' only-one-video' : "")}>
                            <SingleVideo selectedVideo={this.fixedSelectedVideos[0]}
                                videos={this.props.videos}
                                showChangeAnglesButton={this.shouldShowAngleButtons()}
                                alignRight={false}
                                isTps={this.props.isTps}
                                onSelectedVideoChanged={(video:IReportVideo) => this.onSelectedVideosChanged(video, 0)}/>
                        </div>
                    :
                <div className={`${VideoControlCompareReportStyle.infoBoxContainer} left`}>
                           <div className={VideoControlCompareReportStyle.emptyVideoContainer}></div>
                    <div className={`${VideoControlCompareReportStyle.infoContainer} left`}>
                               <p>No video captured for the shot.</p>
                           </div>
                       </div>
                }
                   {this.props.videos2 && this.props.videos2.length > 0 
                    ?
                        <div className={"single-video" +  (this.props.videos2.length === 1 || this.props.videos2.length === 2 ? ' only-one-video' : "")}>
                            <SingleVideo selectedVideo={this.fixedSelectedVideos[1]}
                                videos={this.props.videos2}
                                showChangeAnglesButton={this.shouldShowAngleButtons2()}
                                alignRight={true}
                                isTps={this.props.isTps}
                                onSelectedVideoChanged={(video: IReportVideo) => this.onSelectedVideosChanged(video, 1)} />
                        </div>
                    :
                <div className={`${VideoControlCompareReportStyle.infoBoxContainer} right`}>
                    <div className={VideoControlCompareReportStyle.emptyVideoContainer}></div>
                    <div className={`${VideoControlCompareReportStyle.infoContainer} right`}>
                               <p>No video captured for the shot.</p>
                           </div>
                       </div>
                }
               </div>;
    }
}
